import { Col, Form, Input, message, Modal, Row } from "antd";
import React from "react";

const TermsAndConditions = Form.create()((props) => {
  const {
    modalVisible,
    handleCloseTerms,
    isChangingPassword
  } = props;

  const FormItem = Form.Item;

  const { getFieldDecorator } = props.form;

  const handleOk = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      if (!err) {
        if (values.new_password !== values.confirm_password) {
          message.error("New Password and Confirm Password doesn't match");
          return;
        }
        props.handleSubmitPassword(values);
      }
    });
  };
  if (props.isClear) {
    props.form.resetFields();
  }
  const onCancelModal = () => {
    props.form.resetFields();
    handleCloseTerms();
  };
  return (
    <Modal
      title="Change Password"
      visible={modalVisible}
      onOk={handleOk}
      onCancel={onCancelModal}
      okButtonProps={{ loading: isChangingPassword }}
      cancelButtonProps={{ disabled: isChangingPassword }}
    >
      <Form layout="vertical">
        <Row gutter={8}>
          <Col xs={24} md={24}>
            {props.ifLoginPage ? (
              <FormItem label="Agent ID">
                {getFieldDecorator("agentId", {
                  rules: [
                    {
                      required: true,
                      whitespace: true,
                      message: "Agent ID is required",
                    },
                  ],
                })(<Input placeholder="Agent ID" />)}
              </FormItem>
            ) : null}

            <FormItem label="Old Password">
              {getFieldDecorator("old_password", {
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: "Old Password is required",
                  },
                ],
              })(<Input.Password placeholder="Old Password" />)}
            </FormItem>

            <FormItem label="New Password">
              {getFieldDecorator("new_password", {
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: "New Password is required. ",
                  },
                  {
                    pattern: /(?=.*\d)/,
                    message: "Should atleast contain 1 Number",
                  },
                  {
                    pattern: /(?=.*[a-z|A-Z])/,
                    message: "Should atleast contain 1 Alphabet",
                  },
                  {
                    min: 8,
                    message: "New password must be 8 characters.",
                  },
                ],
              })(<Input.Password placeholder="New Password" />)}
            </FormItem>

            <FormItem label="Confirm Password">
              {getFieldDecorator("confirm_password", {
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: "Confirm Password is required. ",
                  },
                  {
                    min: 8,
                    message: "Confirm password must be 8 characters. ",
                  },
                ],
              })(<Input.Password placeholder="Confirm Password" />)}
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
});

export default TermsAndConditions;
